import React, { Suspense } from "react";

import { Dialog as BaseDialog, DialogContent } from "./base/dialog";
import { Spinner } from "./spinner";

export function Dialog({
  children,
  open,
  onOpenChange,
  className,
}: {
  children?: React.ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  className?: string;
}) {
  return (
    <BaseDialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={className} showCloseButton={false}>
        {/* Content that reads suspending data (e.g. a catalog hook) shows the
            spinner here instead of blanking the whole page. */}
        <Suspense
          fallback={
            <div className="flex min-h-32 items-center justify-center">
              <Spinner />
            </div>
          }
        >
          {children}
        </Suspense>
      </DialogContent>
    </BaseDialog>
  );
}
